import React, { useState } from "react";
import ReactQuill from "react-quill";
import {
  Box,
  Modal,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import Toast from "@/utils/toastManager";
import { sendInfoMail } from "@/api/adminApis/adminApis";
import { infoMessageTemplate } from "@/data/utils/infoMessageTemplate";

export const RequestInfoModal = ({ req, onClose, onEmailSent }) => {
  const [message, setMessage] = useState(infoMessageTemplate(req.name));
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    try {
      setLoading(true);
      await sendInfoMail(
        req?.email,
        message,
      );
      Toast.success("Email sent successfully!");
      if (onEmailSent) onEmailSent();
      onClose();
    } catch {
      Toast.error("Failed to send email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          width: 600,
          maxHeight: 700,
          p: 4,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Mail Body
        </Typography>

        <Box sx={{ mb: 2, maxHeight: 550, overflowY: "scroll" }} >
          <ReactQuill value={message} onChange={setMessage} theme="snow" />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button onClick={onClose} variant="outlined" color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleSend}
            variant="contained"
            color="info"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : "Send"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
